import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  SimpleGrid,
  useToast,
  Center,
  Text,
} from "@chakra-ui/react";
import LayoutView from "../../components/layout";
import { useNavigate } from "react-router-dom";

const RegisterPatient = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const patientTypeArr = [
    { type: "Student", href: "/auth/register/bio-data2", id: "1" },
    { type: "Senior staff", href: "/auth/register/bio-data", id: "2" },
    {
      type: "Senior staff dependent",
      href: "/auth/register/bio-data",
      id: "3",
    },
    { type: "Junior staff", href: "/auth/register/bio-data", id: "4" },
    {
      type: "Junior staff dependent",
      href: "/auth/register/bio-data",
      id: "5",
    },
    { type: "Others", href: "/auth/register/bio-data", id: "6" },
  ];

  return (
    <LayoutView>
      <Flex align="center" justifyContent="center" minH="60vh">
        <Box
          mt={4}
          p={8}
          maxWidth="600px"
          w="full"
          borderWidth={1}
          borderRadius={8}
          boxShadow="lg"
        >
          <Box textAlign="center">
            <Heading> Register Patient </Heading>
          </Box>
          <Box padding="24px" w="full">
            <Heading mt="40px" textDecoration={"underline"} fontSize="25px">
              Patient Type{" "}
            </Heading>
            <SimpleGrid my="10px" columns={{ base: 1, md: 2 }} spacing="19px">
              {patientTypeArr?.map((pType) => (
                <Center
                  key={pType?.id}
                  cursor={"pointer"}
                  onClick={() => {
                    navigate(pType?.href, {
                      state: { patientType: pType?.type },
                    });
                  }}
                  borderRadius="8px"
                  w="full"
                  h="44px"
                  color={"#19518D"}
                  border={"1px solid #19518D"}
                  bg={"white"}
                >
                  {pType.type}
                </Center>
              ))}
            </SimpleGrid>
            <Text textAlign={"center"} fontSize={"16px"} mt="22px">
              Already have an account?{" "}
              <Text
                cursor={"pointer"}
                as="span"
                onClick={() => navigate("/auth/login")}
                color={"#19508d"}
              >
                Login here
              </Text>
            </Text>
          </Box>
        </Box>
      </Flex>
    </LayoutView>
  );
};

export default RegisterPatient;
